import { gateBooleanToBoolean, gateNonstandardDateToDate } from "../../sg-core/utils/GateSupport";
import { base64ToJson } from "../../sg-core/utils/json.helpers";
import { IAuditResult } from "../services/auditService";
import IAudit, { EAuditStatus, isAuditStatus } from "../interfaces/IAudit";
import { IAuditItem } from "../interfaces/IAuditItem";


const AuditItemMapper = {
    apiToDomain: (api: IAuditResult["auditointi"]): IAuditItem => {

        if (!api.lomakedata) { console.warn("[AuditMapper.apiToDomain]: Audit api result is missing lomakedata"); };
        const decodedBase64 = api.lomakedata ? base64ToJson(api.lomakedata) : { formSchema: {}, notes: {} };
        const decodedMetaData = api.metadata ? base64ToJson(api.metadata) : null;


        const metaData = decodedMetaData || decodedBase64.metaData;
        const statics = decodedMetaData?.statics || decodedBase64?.statics;


        if (!metaData) { console.warn("[AuditMapper.apiToDomain]: Audit is missing fromSchema or metaData"); };

        const status = isAuditStatus(api.tila) ? api.tila : EAuditStatus.Unknown;

        const { otsikko: title, alue: target } = api;

        return {
            id: api.id,
            guid: api.guid,
            title,


            target,
            status,
            formType: api.lomake,
            work: api.tyo,

            mapLocation: api.karttasijainti,

            statics: statics ? statics : undefined,


            metaData: metaData ? {
                ...metaData,
                responsiblePerson: api.vastuuhenkilo,
                target
            } : {},

            submitter: api.kirjaaja,
            submittedAt: api.kirjattu ? gateNonstandardDateToDate(api.kirjattu) || null : null,

            removed: gateBooleanToBoolean(api.poistettu)
        }
    },

    auditToItem: (audit: IAudit): IAuditItem => {
        const {
            id,
            guid,
            title,
            target,
            status,
            formType,
            work,
            metaData,
            submitter,
            submittedAt,
            removed,
        } = audit

        return {
            id,
            guid,
            title,
            target,
            status,
            formType,
            work,
            metaData,
            submitter,
            submittedAt,
            removed,
            statics: audit.statics

        }
    },

};

export default AuditItemMapper
